import React, { useState } from "react";
import confetti from "canvas-confetti";

import {
  FaHeart,
  FaStar,
  FaCarSide,
  FaRoad,
  FaCalendarAlt,
} from "react-icons/fa";
import { BsFuelPump } from "react-icons/bs";
import { useRef } from "react";

const CarCard = ({ car }) => {
  const [liked, setLiked] = useState(false);
  const heartRef = useRef(null);

 const shootConfetti = () => {
  const scalar = 1.2;

  // Get heart icon position
  if (!heartRef.current) return;
  const rect = heartRef.current.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  const triangle = confetti.shapeFromPath({
    path: "M0 10 L5 0 L10 10z",
  });
  const square = confetti.shapeFromPath({
    path: "M0 0 L10 0 L10 10 L0 10 Z",
  });
  const coin = confetti.shapeFromPath({
    path: "M5 0 A5 5 0 1 0 5 10 A5 5 0 1 0 5 0 Z",
  });
  const tree = confetti.shapeFromPath({
    path: "M5 0 L10 10 L0 10 Z",
  });

  const defaults = {
    spread: 360,
    ticks: 60,
    gravity: 0.3,
    decay: 0.92,
    startVelocity: 30,
    shapes: [triangle, square, coin, tree],
    scalar,
    origin: { x, y },
  };

  const shoot = () => {
    confetti({ ...defaults, particleCount: 40 });
    confetti({ ...defaults, particleCount: 5 });
    confetti({
      ...defaults,
      particleCount: 15,
      scalar: scalar / 2,
      shapes: ["circle"],
    });
  };

  shoot();
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);
};


  const toggleLike = () => {
    if (!liked) {
      shootConfetti();
    }
    setLiked(!liked);
  };
  return (
    <div className="card shadow-sm rounded-4 overflow-hidden">
      <div className="position-relative">
        <img
          src={car.image}
          className="card-img-top"
          alt={car.name}
          style={{ height: "200px", objectFit: "cover" }}
        />
        <span className="badge bg-secondary position-absolute top-0 start-0 m-2">
          {car.brand}
        </span>
        <span className="badge bg-success position-absolute top-0 start-50 translate-middle-x m-2">
          Available
        </span>
        <div
          className="position-absolute top-0 end-0 m-2"
          style={{ zIndex: 5 }}
        >
          <FaHeart
            ref={heartRef}
            onClick={toggleLike}
            className="position-absolute top-0 end-0 m-2"
            style={{
              color: liked ? "red" : "white",
              cursor: "pointer",
              fontSize: "25px",
              transition: "transform 0.1s ease-in-out",
            }}
          />
        </div>
      </div>
      <div className="card-body">
        <h5 className="card-title">{car.name}</h5>
        <div className="d-flex align-items-center mb-2">
          <div className="text-warning me-2">{Array(4).fill(<FaStar />)}</div>
          <span className="text-muted">(4.0) {car.reviews} Reviews</span>
        </div>
        <h4 className="text-primary">
          ${car.price} <small className="text-muted">/ Day</small>
        </h4>
        <hr />
        <div className="d-flex justify-content-between text-muted">
          <div>
            <FaCarSide className="me-1" /> Auto
          </div>
          <div>
            <FaRoad className="me-1" /> {car.distance} KM
          </div>
          <div>
            <BsFuelPump className="me-1" /> {car.fuel}
          </div>
          <div>
            <FaCalendarAlt className="me-1" /> {car.year}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
